import { Maybe, Operation } from '../../../__generated__/globalTypes'

import {
  StripeOrderFragment,
  stripeOrderFragmentString,
} from '../../fragments/__generated__/StripeOrderFragment'

import createStripeOrderRawString from '../CreateStripeOrder.graphql'

const createStripeOrderString = [
  createStripeOrderRawString,
  stripeOrderFragmentString,
].join('\n\n')

export type CreateStripeOrderData = {
  createStripeOrder: {
    stripeOrder: StripeOrderFragment
  }
}

export type CreateStripeOrderVariables = {
  itemCode: string
  coupon?: Maybe<string>
  quantity?: Maybe<number>
}

export type CreateStripeOrder = Operation<
  CreateStripeOrderData,
  CreateStripeOrderVariables
>

export const CreateStripeOrder = ({
  itemCode,
  coupon,
  quantity,
}: CreateStripeOrderVariables): CreateStripeOrder => ({
  query: createStripeOrderString,
  variables: {
    itemCode,
    coupon,
    quantity,
  },
})
